import { render, staticRenderFns } from "./tithiform.vue?vue&type=template&id=ddd7a398&scoped=true"
import script from "./tithiform.vue?vue&type=script&lang=js"
export * from "./tithiform.vue?vue&type=script&lang=js"
import style0 from "./tithiform.vue?vue&type=style&index=0&id=ddd7a398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd7a398",
  null
  
)

export default component.exports